import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import RoastPage from "@/pages/RoastPage";
import HelpPage from "@/pages/HelpPage";

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: '#111111',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#F5F5F5',
            fontFamily: 'Manrope, sans-serif',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/roast" element={<RoastPage />} />
          <Route path="/help" element={<HelpPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
